import { z } from 'zod';
/**
 * Stable, machine-readable error codes. The frontend maps a code to a
 * translated message; it never parses the human-readable `message`.
 * Add codes, never repurpose them.
 */
export const ERROR_CODES = [
    'VALIDATION_FAILED',
    'USERNAME_TAKEN',
    'NO_PLATFORM_ACCESS',
    'UA_UNAVAILABLE',
    'UNAUTHENTICATED',
    'INVALID_CREDENTIALS',
    'FORBIDDEN',
    'NOT_FOUND',
    'CONFLICT',
    'UNIQUE_VIOLATION',
    'FOREIGN_KEY_VIOLATION',
    'RATE_LIMITED',
    'IDEMPOTENCY_KEY_REUSED',
    'REQUEST_IN_PROGRESS',
    'PAYLOAD_TOO_LARGE',
    'UNPROCESSABLE',
    'INTERNAL_ERROR',
    'SERVICE_UNAVAILABLE',
    // Shared platform codes. Clients translate the code; `error.data` carries
    // safe case-specific detail.
    'IN_USE',
    'BRANCH_NOT_ALLOWED',
    'CODE_TAKEN',
    'INVALID_STATE',
    'NOTHING_TO_CHANGE',
    'CUSTOMERS_UNAVAILABLE',
    'PHONE_TAKEN',
    'CUSTOMER_DELETED',
    'CUSTOMERS_FORBIDDEN',
    // Debts (debts.md sections 3 and 6.3). `error.data` carries `limit` for
    // DEBT_LIMIT_EXCEEDED and `date` (ISO-8601) for MOVEMENT_BEFORE_LOCKED.
    'DEBT_LIMIT_EXCEEDED',
    'MOVEMENT_DATE_IN_FUTURE',
    'MOVEMENT_BEFORE_LOCKED',
    'ACCOUNT_BALANCE_NOT_ZERO',
    // Several accounts per debtor (debts.md version 1.1). `error.data` carries
    // `debtorId` and `name` for PHONE_EXISTS; ACCOUNT_NAME_EXISTS answers an
    // account name already used by the debtor in that branch.
    'PHONE_EXISTS',
    'ACCOUNT_NAME_EXISTS',
    // The shared phone rule (customers.md section 9.3).
    'PHONE_REQUIRED',
    'PHONE_INVALID',
    'PHONE_NOT_MOBILE',
    'PHONE_COUNTRY_NOT_ALLOWED',
    // WhatsApp phone verification (customers.md section 10, debts.md section
    // 21). The OTP_* codes and the receipt codes come from Customers and are
    // passed on unchanged; `error.data` carries `attemptsLeft`,
    // `retryAfterSeconds` or `failureCode` as Customers sent them.
    'PHONE_VERIFICATION_REQUIRED',
    'PHONE_VERIFICATION_INVALID',
    'PHONE_VERIFICATION_RECEIPT_EXPIRED',
    'OTP_INVALID',
    'OTP_EXPIRED',
    'OTP_ATTEMPTS_EXCEEDED',
    'OTP_RESEND_TOO_SOON',
    'OTP_SEND_LIMIT',
    'OTP_SEND_FAILED',
    'OTP_ALREADY_VERIFIED',
    'OTP_ALREADY_CONSUMED',
    'OTP_BINDING_MISMATCH',
    'OTP_NOT_VERIFIED',
    'OTP_CONSUME_WINDOW_PASSED',
    'IDEMPOTENCY_CONFLICT',
    // إعادة التحقق on a customer whose last Customers call did not fail on its verification.
    'REVERIFY_NOT_NEEDED',
    // Incomplete customer details and duplicate customers (debts.md section 22).
    // `error.data` of CUSTOMER_PROFILE_INCOMPLETE carries `debtorId`, `name` and
    // `issues`; DEBTOR_MERGE_HIDDEN_NAME_CONFLICT carries the target's `name`.
    'CUSTOMER_PROFILE_INCOMPLETE',
    'DEBTOR_MERGE_NOT_ALLOWED',
    'DEBTOR_MERGE_STALE',
    'DEBTOR_MERGE_HIDDEN_NAME_CONFLICT',
    // A move refused while a movement of the customer is being sent to Customers.
    'CUSTOMERS_CALL_IN_FLIGHT',
];
export const errorCodeSchema = z.enum(ERROR_CODES);
export const fieldErrorSchema = z.object({
    path: z.string(),
    message: z.string(),
    code: z.string().optional(),
});
//# sourceMappingURL=api-error.js.map